var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptVisaImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    rx: 3,
    fill: "#00579F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4669 21.535H19.3887L21.314 10.4995H24.3921L22.4669 21.535Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6256 10.7696C33.0184 10.5463 32.0554 10.2998 30.8646 10.2998C27.8247 10.2998 25.684 11.8024 25.6709 13.9507C25.6457 15.5358 27.2036 16.4161 28.3688 16.9446C29.5597 17.4846 29.9645 17.8371 29.9645 18.3185C29.9524 19.0578 29.0022 19.3986 28.1159 19.3986C26.8869 19.3986 26.2284 19.2229 25.2277 18.8116L24.8224 18.6353L24.3916 21.1125C25.1136 21.4174 26.4437 21.6879 27.8247 21.6998C31.0546 21.6998 33.1574 20.2204 33.1823 17.9311C33.1946 16.6748 32.372 15.7122 30.5985 14.9257C29.5218 14.4207 28.8625 14.0802 28.8625 13.5636C28.8751 13.0939 29.4201 12.6129 30.6355 12.6129C31.6362 12.5893 32.3715 12.8123 32.9285 13.0354L33.2069 13.1526L33.6256 10.7696Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7169 17.6255C37.9704 16.9916 38.9459 14.5379 38.9459 14.5379C38.9331 14.5614 39.1989 13.8922 39.3509 13.4814L39.566 14.4322C39.566 14.4322 40.149 17.0738 40.2756 17.6255C39.7945 17.6255 38.3249 17.6255 37.7169 17.6255ZM41.5167 10.4995H39.1356C38.4014 10.4995 37.8435 10.6989 37.5267 11.4151L32.9543 21.5349H36.1843C36.1843 21.5349 36.716 20.1728 36.8303 19.8795C37.1847 19.8795 40.3267 19.8795 40.7826 19.8795C40.8709 20.2669 41.1499 21.5349 41.1499 21.5349H44L41.5167 10.4995Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8168 10.4995L13.8021 18.0247L13.4727 16.4985C12.9154 14.7375 11.1674 12.8241 9.2168 11.8728L11.9781 21.5233H15.2333L20.0718 10.4995H16.8168Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0033 10.4995H6.05067L6 10.7225C9.86336 11.6383 12.422 13.8457 13.4732 16.4989L12.3966 11.4271C12.2193 10.7223 11.6746 10.5228 11.0033 10.4995Z",
    fill: "#FAA61A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptVisaImage);
export default __webpack_public_path__ + "static/media/accept-visa-image.0e1170c573f2a613fe8b5a97787547a1.svg";
export { ForwardRef as ReactComponent };